import React from "react";
import { Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";

import { supportIsLoggedIn } from "src/store/support/selector";
import ForcedLightTheme from "src/components/ForcedLightTheme";
import Login from "src/pages/accountant/Login";
import MyClients from "src/pages/accountant/MyClients";
import ForgotPassword from "src/pages/accountant/ForgotPassword";
import ResetPassword from "src/pages/accountant/ResetPassword";
import InviteAccept from "src/pages/accountant/InviteAccept";

function AccountantRouter() {
  const isLoggedIn = useSelector(supportIsLoggedIn);

  return (
    <ForcedLightTheme>
      <Switch>
        {/* Public routes — reachable whether or not the accountant is signed in. */}
        <Route
          path="/accountant/invite/:invitationId"
          component={InviteAccept}
        />
        <Route path="/accountant/forgot-password" component={ForgotPassword} />
        <Route path="/accountant/reset-password" component={ResetPassword} />
        <Route path="/accountant/login" component={Login} />
        {/* Landing — My Clients when signed in, branded login otherwise. */}
        <Route render={() => (isLoggedIn ? <MyClients /> : <Login />)} />
      </Switch>
    </ForcedLightTheme>
  );
}

export default AccountantRouter;
